import React from "react";

/*eslint-disable */

declare const window: any;

interface CategoriesComponentProps {
    setSelectedCategories: any,
    selectedCategories: any,
    categorias: any
}

const CategoriesComponent: React.FC<CategoriesComponentProps> = ({setSelectedCategories, selectedCategories, categorias}) => {
  return <div className="categories-vehiculos-component">
    <div className={`categoria-vehiculos-component ${selectedCategories === "Todos" ? "active" : ""}`} onClick={() => setSelectedCategories("Todos")}>Todos</div>
    {
      categorias.sort((a:any, b:any) => a.order - b.order).map((item: any, index:number) => 
        <div className={`categoria-vehiculos-component ${selectedCategories === item?.category ? "active" : ""}`} onClick={() => setSelectedCategories(item?.category)}>{item?.category}</div>
      )
    }
  </div>;
};

export default CategoriesComponent;
